import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import crudModes from 'Common/constants/crudModes';
import ModalForm from 'Common/components/form/ModalForm';

import TrancheForm from '../TrancheForm/TrancheForm';

const CreateTrancheModal = ({ isOpen, onClose, onFormSubmit, campaignData, trancheToCopy }) => {
	const { t } = useTranslation();

	return (
		<ModalForm
			label="tranche-create"
			isOpen={isOpen}
			onClose={onClose}
			onFormSubmit={onFormSubmit}
			heading={t('Create Tranche')}
		>
			{(setIsFormDirty, handleSubmit, onCancel) => (
				<TrancheForm
					data={trancheToCopy}
					mode={crudModes.CREATE}
					onSubmit={handleSubmit}
					onCancel={onCancel}
					onDirty={setIsFormDirty}
					campaignData={campaignData}
				/>
			)}
		</ModalForm>
	);
};

CreateTrancheModal.defaultProps = {
	isOpen: false,
	campaignData: {},
	trancheToCopy: {},
	onClose: () => {},
	onFormSubmit: () => {},
};

CreateTrancheModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	onFormSubmit: PropTypes.func,
	campaignData: PropTypes.shape({}),
	trancheToCopy: PropTypes.shape({}),
};

export default CreateTrancheModal;
